import AbstractCommand from "../../application/AbstractCommand";

export default class InitializeLanguageConfigCommand extends AbstractCommand {
    constructor(dispatcher, assetLibrary, languageModel) {
        super(dispatcher);

        this._assetLibrary = assetLibrary;
        this._languageModel = languageModel;
    }

    execute(evt) {
        console.log("InitializeLanguageConfigCommand");
        const languagesJSON = this._assetLibrary.getAsset("languages");
        this._languageModel.setPropertiesFromObject(languagesJSON);
    }
}